var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassVis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.18294 10.1984C1.61632 9.46228 1.33301 9.09422 1.33301 8.0013C1.33301 6.90838 1.61632 6.54032 2.18294 5.80419C3.31432 4.33434 5.21175 2.66797 7.99968 2.66797C10.7876 2.66797 12.685 4.33434 13.8164 5.80419C14.383 6.54032 14.6663 6.90838 14.6663 8.0013C14.6663 9.09422 14.383 9.46228 13.8164 10.1984C12.685 11.6683 10.7876 13.3346 7.99968 13.3346C5.21175 13.3346 3.31432 11.6683 2.18294 10.1984Z",
    stroke: "#A0A0AB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 8C10 9.10457 9.10457 10 8 10C6.89543 10 6 9.10457 6 8C6 6.89543 6.89543 6 8 6C9.10457 6 10 6.89543 10 8Z",
    stroke: "#A0A0AB",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassVis);
export default __webpack_public_path__ + "static/media/passVis.0f6d69b85e04114e3fefb656685e6a70.svg";
export { ForwardRef as ReactComponent };